<template>
    <BaseChip :size="size" :class="sourceClasses[source]">
        <template #leading>
            <i v-if="source === 'nadia'" class="bi bi-stars text-[11px]/none" aria-hidden="true"></i>
            <span v-else class="source-marker" aria-hidden="true"></span>
        </template>
        <slot />
    </BaseChip>
</template>

<script lang="ts">
import type { BaseChipSize } from "~vue/components/BaseChip.vue";

export type SourceChipSource = "neutral" | "nadia" | "three-sixty" | "journeys" | "self-reflect" | "team-reflect";

interface SourceChipProps {
    source?: SourceChipSource;
    size?: BaseChipSize;
}
</script>

<script setup lang="ts">
import BaseChip from "~vue/components/BaseChip.vue";

const { source = "neutral", size = "2xs" } = defineProps<SourceChipProps>();

const sourceClasses: Record<SourceChipSource, string> = {
    neutral: "source-neutral",
    nadia: "source-nadia",
    "three-sixty": "source-three-sixty",
    journeys: "source-journeys",
    "self-reflect": "source-self-reflect",
    "team-reflect": "source-team-reflect",
};
</script>

<style scoped>
@reference "../../../css/tailwind.css";

@layer components {
    .source-marker {
        @apply size-1.5 shrink-0 rounded-full;
        background-color: var(--base-chip-marker, currentColor);
    }
    .source-neutral {
        --base-chip-bg: var(--color-chip-neutral-bg);
        --base-chip-text: var(--color-chip-neutral-text);
    }

    .source-nadia {
        --base-chip-bg: var(--color-chip-nadia-bg);
        --base-chip-text: var(--color-chip-nadia-text);
    }

    .source-three-sixty {
        --base-chip-bg: var(--color-chip-three-sixty-bg);
        --base-chip-text: var(--color-chip-three-sixty-text);
    }

    .source-journeys {
        --base-chip-bg: var(--color-chip-journeys-bg);
        --base-chip-text: var(--color-chip-journeys-text);
        --base-chip-marker: var(--color-chip-journeys-marker);
    }

    .source-self-reflect {
        --base-chip-bg: var(--color-chip-self-reflect-bg);
        --base-chip-text: var(--color-chip-self-reflect-text);
    }

    .source-team-reflect {
        --base-chip-bg: var(--color-chip-team-reflect-bg);
        --base-chip-text: var(--color-chip-team-reflect-text);
    }
}
</style>
